<template>
  <div v-if="user">
    <button
      v-if="user.verified_status === statuses.new"
      @click="emitOpen"
      class="verification-desc verification-desc--new"
    >
      <i class="demo-icon icon-warning verification-desc__icon" />
      <span>
            {{ trans.get('profile:edit.verify_profile_button') }}
            </span>
    </button>
    <p
      v-else-if="user.verified_status === statuses.uploaded"
      class="verification-desc verification-desc--in-progress"
      disabled
    >
      <i class="demo-icon icon-clock verification-desc__icon" />
      <span>
                {{ trans.get('profile:edit.verification_in_progress') }}
            </span>
    </p>
    <p
      v-else-if="user.verified_status === statuses.accepted"
      class="verification-desc verification-desc--positive"
    >
      <i class="demo-icon icon-verified verification-desc__icon" />
      <span>
                {{ trans.get('profile:edit.profile_verified') }}
            </span>
    </p>
    <button
      v-else-if="user.verified_status === statuses.rejected"
      @click="emitOpen"
      class="verification-desc verification-desc--new"
    >
      <i class="demo-icon icon-warning verification-desc__icon" />
      <span>
                {{ trans.get('profile:edit.verify_profile_button') }}
            </span>
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'VerificationStatusButton',
  props: {},
  data() {
    return {
      statuses: {},
    };
  },
  computed: {
    ...mapGetters('user', {
      user: 'getUser',
    })
  },
  methods: {
    emitOpen() {
      this.$eventHub.$emit('VerificationStatusOpen', this.profileId);
    },
  },
  mounted() {
    this.statuses = window.globals.user_image_verification;
  }
};
</script>

<style scoped>

</style>
